module.exports = __webpack_public_path__ + "static/media/01_design-logo_yeutech.5011b58d.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/01_design-logo_yeutech.png
// module id = 52
// module chunks = 0